import { render, staticRenderFns } from "./tasksList.vue?vue&type=template&id=62df5418&"
import script from "./tasksList.vue?vue&type=script&lang=js&"
export * from "./tasksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports